import React, { useMemo } from 'react';
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';

import { listWorkspaceRubrics } from 'js/actions/rubric-actions';
import { useWorkspaceRubrics } from 'js/hooks/useWorkspaceRubrics';
import RubricsListComponent from '../components/RubricsListComponent';

function RubricsListContainer({ listWorkspaceRubrics }) {
  const { workspaceId } = useParams();
  const { rubrics, isLoading, hasLoaded, error } = useWorkspaceRubrics(
    workspaceId,
    listWorkspaceRubrics
  );

  const rows = useMemo(() => rubrics, [rubrics]);
  const loaded = hasLoaded && !isLoading;

  return (
    <RubricsListComponent
      workspaceId={workspaceId}
      rows={rows}
      loaded={loaded}
      error={error}
    />
  );
}

export default connect(null, { listWorkspaceRubrics })(RubricsListContainer);
